import { API_ROOT } from '../config/ApiConfig';
import { generateRequestHeaders, extractErrorMessage } from '../service/ApiService';
import { BannerObject, BannerSeverity } from '../models/banner/BannerObject';

const BANNER_ROOT = `${API_ROOT}/maintenance-banner`;

export async function getActiveBanner(): Promise<BannerObject | null> {
  try {
    const response = await fetch(`${BANNER_ROOT}/active`, {
      headers: generateRequestHeaders()
    });
    if (!response.ok) {
      return null;
    }
    const body = await response.text();
    return body ? JSON.parse(body) : null;
  } catch {
    return null;
  }
}

export async function getActiveBannerForManage(): Promise<BannerObject | null> {
  try {
    const response = await fetch(`${BANNER_ROOT}/manage`, {
      headers: generateRequestHeaders()
    });
    if (!response.ok) {
      return null;
    }
    const body = await response.text();
    return body ? JSON.parse(body) : null;
  } catch {
    return null;
  }
}

export async function createBanner(
  title: string,
  message: string,
  severity: BannerSeverity,
  expiryDate: string
): Promise<BannerObject> {
  const response = await fetch(BANNER_ROOT, {
    method: 'POST',
    headers: generateRequestHeaders(),
    body: JSON.stringify({ title, message, severity, expiryDate })
  });
  if (!response.ok) {
    throw new Error(await extractErrorMessage(response, 'Failed to publish maintenance banner'));
  }
  return response.json();
}

export async function extendBanner(bannerId: string, newExpiryDate: string): Promise<BannerObject> {
  const response = await fetch(`${BANNER_ROOT}/extend`, {
    method: 'PUT',
    headers: generateRequestHeaders(),
    body: JSON.stringify({ bannerId, newExpiryDate })
  });
  if (!response.ok) {
    throw new Error(await extractErrorMessage(response, 'Failed to extend maintenance banner'));
  }
  return response.json();
}

export async function deleteBanner(): Promise<void> {
  const response = await fetch(BANNER_ROOT, {
    method: 'DELETE',
    headers: generateRequestHeaders()
  });
  if (!response.ok) {
    throw new Error('Failed to delete maintenance banner');
  }
}
